import React, { Component } from "react";
import autoBind from "auto-bind";

class FormWrapper extends Component {
  constructor(props) {
    super(props);

    autoBind.react(this);
  }

  state = {
    fields: [],
    canSubmit: true
  };

  static getCanSubmit(fields) {
    let canSubmit = true;

    for (const field of fields) {
      if (field.type === "checkbox" || field.type === "newCheckbox") {
        if (field.required && field.selected && field.selected.length === 0) {
          canSubmit = false;
        }
      } else if (field.required && !field.value) {
        canSubmit = false;
      }
    }

    return canSubmit;
  }

  handleChange(field, value) {
    this.setState(prevState => {
      const fields = prevState.fields.map(current =>
        current.name === field.name
          ? { ...current, value, edited: true }
          : current
      );

      return {
        fields,
        canSubmit: FormWrapper.getCanSubmit(fields)
      };
    });
  }

  handleCheckboxChange(field, value) {
    this.setState(prevState => {
      const fields = prevState.fields.map(current =>
        current.name === field.name
          ? { ...current, selected: value }
          : current
      );

      return {
        fields,
        canSubmit: FormWrapper.getCanSubmit(fields)
      };
    });
  }

  clear() {
    this.setState(prevState => ({
      fields: prevState.fields.map(field => ({
        ...field,
        value: "",
        edited: false
      }))
    }));
  }

  render() {
    throw new Error(
      "FormWrapper is abstract component. It should not be executed without overriding."
    );
  }
}

export default FormWrapper;
